import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { EmailRoutinePage } from '~/features/routines/email-routine-page';

function EmailRoute(): ReactElement {
  const { ruleId } = Route.useParams();
  return <EmailRoutinePage key={ruleId} ruleId={ruleId} />;
}

/** An email rule, on its own page (docs/plans/routines.md R6): only its owner sees it. */
export const Route = createFileRoute('/_app/routines/email/$ruleId')({
  component: EmailRoute,
});
